import { memo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import useUtilisationBarStyles from '../../../styles/useUtilisationBarStyles';
import clsx from 'clsx';

const ProgressBar = memo(function ProgressBar(props: { percentage: number }) {
  const { percentage } = props;
  const classes = useUtilisationBarStyles();

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className={classes.value}>{`${percentage.toLocaleString()} %`}</div>
      <div className={classes.root}>
        <div
          className={clsx(classes.bar, {
            low: percentage < 30,
            medium: percentage >= 30 && percentage <= 70,
            high: percentage > 70,
          })}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
});

export function renderUtilisation(params: ICellRendererParams) {
  return <ProgressBar percentage={params.data.utilisation} />;
}
